import gql from 'graphql-tag';

export const UPDATE_LOOK_FORM_SECTION_FILTER = gql`
  mutation updateLookFormSectionFilter($filter: FormSectionFilterInput!, $orderBy: [String]) {
    updateLookFormSectionFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
